import { useState } from "react";
import { participationCards } from "@/mocks/publico";

export default function PublicParticipationSection() {
  const [activeModal, setActiveModal] = useState<string | null>(null);

  return (
    <section id="participacao" className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">Ajude a cuidar da arborização urbana</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            A participação da comunidade é essencial para manter o patrimônio verde da cidade saudável e seguro.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {participationCards.map((card) => (
            <button
              key={card.title}
              onClick={() => setActiveModal(card.title)}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-background-300/60 text-left transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-3">
                <i className={`${card.icon} text-primary-600 text-lg w-5 h-5 flex items-center justify-center`} />
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{card.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{card.description}</p>
            </button>
          ))}
        </div>

        {/* Mock Modal */}
        {activeModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            <div className="absolute inset-0 bg-black/40" onClick={() => setActiveModal(null)} />
            <div className="relative bg-white rounded-2xl p-6 md:p-8 max-w-md w-full border border-background-200 shadow-sm">
              <button
                onClick={() => setActiveModal(null)}
                className="absolute top-4 right-4 p-1.5 rounded-md hover:bg-background-100 text-foreground-400 cursor-pointer"
              >
                <i className="ri-close-line w-5 h-5 flex items-center justify-center" />
              </button>
              <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-4">
                <i className="ri-mail-send-line text-primary-600 text-xl w-6 h-6 flex items-center justify-center" />
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2">{activeModal}</h3>
              <p className="text-sm text-foreground-600 mb-4">
                Esta funcionalidade estará disponível em breve. Por enquanto, entre em contato pelo e-mail abaixo para registrar sua solicitação.
              </p>
              <div className="bg-background-50 rounded-lg p-4 border border-background-200/70">
                <p className="text-sm font-medium text-foreground-900 mb-1">E-mail para contato:</p>
                <a href="mailto:cena@cenatech.com.br" className="text-sm text-primary-600 hover:text-primary-700 transition-colors">
                  cena@cenatech.com.br
                </a>
              </div>
              <button
                onClick={() => setActiveModal(null)}
                className="mt-4 w-full px-4 py-2.5 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                Entendi
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}